import { render } from "./ElementOutline.vue?vue&type=template&id=2d8ce9c0&scoped=true&ts=true"
import script from "./ElementOutline.vue?vue&type=script&lang=ts"
export * from "./ElementOutline.vue?vue&type=script&lang=ts"

import "./ElementOutline.vue?vue&type=style&index=0&id=2d8ce9c0&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8ce9c0"]])

export default __exports__